module.exports = __webpack_public_path__ + "img/wljg001.515e0684.jpg";